import { createContext } from 'react';
import LoginService from '../Services/LoginService';

const LoginContext = createContext<LoginService>(new LoginService());
export default LoginContext;
